var mylatesttap;
export function doubletapSelect(ev) {
  if (mylatesttap === undefined) mylatesttap = new Date().getTime();

  var now = new Date().getTime();
  var timesince = now - mylatesttap;

  if((timesince < 600) && (timesince > 0)) {
    if(ev.target){
      ev.target.select();
    }
  }

  mylatesttap = new Date().getTime();
}



// WEBPACK FOOTER //
// ./src/helpers/doubleTapHelper.js